import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../types";

export default function UnlockedAchievementContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  const achievement = events
    .map((e, index) => (index !== 0 ? " " : "") + e.achievement)
    .join("");

  return (
    <Trans
      i18nKey="notifications.unlockedAchievement"
      values={{ achievement }}
    />
  );
}
